module.exports = __webpack_public_path__ + "static/media/delete_yellow.631697ec.svg";